import React from 'react'
import Menu from './Menu'
import BackToTop from '../PageComponents/BackToTop'
import useScrolledDown from '../Hooks/useScrolledDown'
import FooterText from '../PageComponents/FooterText'

export default function Layout ({ children }) {
  const scrolledDown = useScrolledDown(100)
  return (
    <main className='block relative ' id='main-site-id'>
      {scrolledDown && <BackToTop />}
      <header>
        <Menu />
      </header>
      <div className={`${scrolledDown ? '' : 'pt-12'}`}>{children}</div>

      <footer className='flex w-full p-8 bg-color_readable text-color_light font-text_readable text-header4 relative z-10'>
        <div className='max-w-sitemax m-auto w-full'>
          <FooterText />
        </div>
      </footer>
    </main>
  )
}
